import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joi from 'joi';
import Fa from 'react-fontawesome';
import { pick } from 'lodash';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector, SubmissionError, submit } from 'redux-form';
import Toggle from 'react-bootstrap-toggle';
import ConfirmButton from '../../../../components/confirm-button';

import {
  createExclusionReason,
  updateExclusionReason,
  deleteExclusionReason,
} from '../../SetupActions';


class AddExclusionReasonForm extends Component {
  constructor() {
    super();
    this.state = {
      deleting: false,
    };
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.onToggleEnabled = this.onToggleEnabled.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }


  close() {
    this.props.reset();
    this.props.onClose();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.props.initialize({ ...nextProps.reason });
    }
  }

  onToggleEnabled() {
    const { selectedEnabled } = this.props;
    this.props.change('enabled', !selectedEnabled);
  }


  handleDelete() {
    const { isAccount } = this.props;
    this.setState({ deleting: true }, () => {
      this.props.dispatch(deleteExclusionReason(this.props.reason._id, isAccount))
        .then(
          () => {
            this.props.onDelete(this.props.reason);
            this.close();
            const el = (<div>Deleted successfully!</div>);
            this.context.addNotification(el, { type: 'success', autoClose: true, onClose: () => {
              this.setState({ deleting: false });
            } });
          },
          (errors) => {
            const e = errors.data || errors;
            const message = e.message || 'Unable to delete';
            const el = (<div>{message}</div>);
            this.context.addNotification(el, { type: 'error', autoClose: false, onClose: () => {
              this.setState({ deleting: false });
            } });
          },
        );
    });
  }

  handleSubmit(data) {
    const { isAccount } = this.props;
    const validFields = ['_id', 'label', 'description', 'enabled'];
    const params = pick(data, validFields);
    const isEditing = this.props.reason._id !== null && this.props.reason._id !== undefined;
    return this.props.dispatch(isEditing ? updateExclusionReason(this.props.reason._id, params, isAccount) : createExclusionReason(params, isAccount))
      .then(
        ({ reason }) => {
          if (isEditing) {
            this.props.onUpdate(reason);
          } else {
            this.props.onCreate(reason);
          }
          this.close();
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          }
          throw new SubmissionError(e);
        },
      );
  }


  renderField({
    input, label, type, disabled, componentClass, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label && label !== '' && <ControlLabel>{label}</ControlLabel>}
        {componentClass !== 'textarea' && <FormControl
          {...input}
          placeholder={label}
          type={type}
          disabled={submitting || disabled}
        />}
        {componentClass === 'textarea' && <FormControl
          {...input}
          placeholder={label}
          type={type}
          componentClass={componentClass}
          rows={3}
          disabled={submitting || disabled}
        />}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  render() {
    const {
      reason, submitting, handleSubmit, valid, error,
      selectedEnabled, isAccount,
    } = this.props;
    const { deleting } = this.state;
    const isEditing = reason?._id !== undefined && reason?._id !== null;

    return (
      <Modal show={this.props.open} onHide={this.close} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <span>{isEditing ? 'Edit' : 'Add'} {isAccount ? 'Experience' : 'Decision'} Exclusion Reason</span>
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            <div>
              {error && <strong className="alert alert-danger">{error}</strong>}
              <Field
                name="label"
                id="label-field"
                type="text"
                component={this.renderField}
                label="Label"
                disabled={deleting}
              />
              <Field
                name="description"
                componentClass="textarea"
                type="textarea"
                component={this.renderField}
                label="Description"
                disabled={deleting}
              />


              <FormGroup>
                <ControlLabel>Enabled:</ControlLabel>
                <div>
                  <Toggle
                    onClick={this.onToggleEnabled}
                    on={<span>YES</span>}
                    off={<span>No</span>}
                    size="xs"
                    onstyle="success"
                    offstyle="danger"
                    active={selectedEnabled}
                    disabled={(submitting || deleting)}
                  />
                </div>
              </FormGroup>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-sm-6 col-sm-push-6">
                <Button bsStyle="link" disabled={(submitting || deleting)} onClick={this.close}>
                  Cancel
                </Button>
                <Button bsStyle="primary" disabled={submitting || !valid || deleting} type="submit">
                  {isEditing &&
                    <span>
                      {!submitting && <span><Fa name="edit" /> Update</span>}
                      {submitting && <span><Fa name="spinner" spin /> Updating</span>}
                    </span>
                  }
                  {!isEditing &&
                    <span>
                      {!submitting && <span><Fa name="plus" /> Add</span>}
                      {submitting && <span><Fa name="spinner" spin /> Adding</span>}
                    </span>
                  }
                </Button>
              </div>


              {!this.props.reason.is_system && isEditing &&
                <div className="col-sm-6 col-sm-pull-6 text-left">
                  <ConfirmButton confirmStyle="danger" disabled={deleting} onConfirm={this.handleDelete}>
                    {!deleting && <span><Fa name="trash" /> Delete</span>}
                    {deleting && <span><Fa name="spinner" spin /> Deleting</span>}
                  </ConfirmButton>
                </div>
              }

            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}


const FORM_NAME = 'exclusionReason';

const selector = formValueSelector(FORM_NAME);

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    selectedEnabled: selector(state, 'enabled'),
  };
}

AddExclusionReasonForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  reason: PropTypes.shape({
    _id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    enable: PropTypes.string,
  }).isRequired,
  valid: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  selectedEnabled: PropTypes.bool,
  isAccount: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
};
AddExclusionReasonForm.defaultProps = {
  open: false,
  selectedEnabled: false,
  isAccount: false,
  onClose: () => {},
  onCreate: () => {},
  onUpdate: () => {},
  onDelete: () => {},
};

const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   enabled: {
  //     presence: true,
  //     inclusion: {
  //       within: [true, false],
  //       message: '^Invalid value of %{value}',
  //     },
  //   },
  //   label: {
  //     presence: { allowEmpty: false },
  //     type: 'string',
  //     length: {
  //       minimum: 5,
  //       maximum: 200,
  //     },
  //   },
  //   description: {
  //     type: 'string',
  //     length: {
  //       maximum: 2048,
  //     },
  //   },
  // };

  const schema = Joi.object({
    enabled: Joi.boolean().required().messages({
      'boolean.base': 'Enabled must be true or false',
      'any.required': 'Enabled is required',
    }),
    label: Joi.string().min(5).max(200).required().messages({
      'string.base': 'Label must be a string',
      'string.empty': 'Label is required',
      'any.required': 'Label is required',
      'string.min': 'Label must be at least 5 characters',
      'string.max': 'Label must be at most 200 characters',
    }),
    description: Joi.string().max(2048).allow('', null).messages({
      'string.base': 'Description must be a string',
      'string.max': 'Description must be at most 2048 characters',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

AddExclusionReasonForm.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

const MainForm = reduxForm({
  form: FORM_NAME,
  validate,
})(AddExclusionReasonForm);

export default connect(mapStateToProps)(MainForm);
